<template>
  <div class="search-base search-container">
    <search-filter-item
      v-if="layout === 'filter'"
      ref="searchFilterItem"
      :label="label"
      @remove="onClickFilterRemove"
    >
      <div>
        <multiselect class="w-full" :options="items" v-model="select" :multiple="true" placeholder="" @input="change" style="z-index: 500"/>
      </div>
    </search-filter-item>
    <search-label-body v-else :label="label" :label-hidden="!label" :columns="options['gridTemplateColumns']">
      <div>
        <multiselect class="w-full" :options="items" v-model="select" :multiple="true" placeholder="" @input="change" style="z-index: 500"/>
      </div>
    </search-label-body>
  </div>
</template>

<script>
import SearchLabelBody from "@/views/list/components/base/SearchLabelBody.vue";
import Multiselect from "vue-multiselect";
import SearchFilterItem from "@/views/list/components/base/SearchFilterItem.vue";

export default {
  name: "SearchSelectMulti",
  components: {
    SearchFilterItem,
    Multiselect,
    SearchLabelBody,
  },
  props: {
    label: {
      default: "기타",
      type: String,
    },
    value: Array,
    setRef: Function,
    readonly: Boolean,
    query: {
      type: Object,
      default: () => {
        return {
          's_s': '',
        }
      },
    },
    options: Object,
  },
  watch: {
  },
  computed: {
    layout() {
      return this.options && this.options.layout ? this.options.layout : 'default';
    },
    isMobile () {
      return !(this.$store.state.verticalNavMenuWidth === 'default')
    },
    initData() {
      const defaultValue = this.options && this.options['default'] ? this.options['default'] : '';
      const _query_keys = Object.keys(this.query)
      const query = this.$route.query;
      const select = query[_query_keys[0]];
      if (select) {
        try {
          return {
            select: select || defaultValue,
          };
        } catch (e) {}
      }
      return {
        select: defaultValue,
      };
    },
    items() {
      return this.options.items || [];
    }
  },
  data() {
    return {
      select: [],
    };
  },
  created() {
    this.select = this.initData.select;
    this.$emit("input", this.select);
  },
  mounted() {
    if (this.setRef) {
      // filter 모드에서 초기화 버튼 클릭시 검색조건을 초기화 하기 위해서 ref 를 연결해주기 위함
      this.setRef('searchFilterItem', this.$refs.searchFilterItem)
    }
  },
  methods: {
    change(data) {
      this.select = data;
      this.$emit("input", data);
    },
    onClickFilterRemove () {
      this.select = '';
      this.$emit("input", this.select);
    }
  },
};
</script>
